module.exports = __webpack_public_path__ + "assets/isolation-icon.c7ca5c63.svg";